import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_vz_site_detail_modal = _resolveComponent("vz-site-detail-modal")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_SiteDetailModal = _resolveComponent("SiteDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      tableFilter: _ctx.tableFilter,
      defaultFilter: _ctx.defaultFilter,
      bulkDelete: _ctx.bulkDelete,
      viewName: _ctx.viewName,
      tableForm: _ctx.formData,
      "onUpdate:tableForm": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData) = $event)),
      addButtonText: `${_ctx.t('pages.form.assignSite')}`,
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      onBulkDelete: _ctx.onBulkDelete,
      permissions: _ctx.permissionModel,
      ref: "Datatable"
    }, {
      "cell-name": _withCtx(({ row: form }) => [
        _createTextVNode(_toDisplayString(form.name) + " ", 1),
        _createVNode(_component_PreviewLink, {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          routerName: {
          name: 'detail.site',
          params: { id: form.webId },
        }
        }, null, 8, ["routerName"])
      ]),
      "cell-code": _withCtx(({ row: form }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(form.code), 1)
      ]),
      "cell-assignDate": _withCtx(({ row: form }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.format.DateTime(form.assignDate)), 1)
      ]),
      "cell-status": _withCtx(({ row: form }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': form.status?.toLowerCase() === 'active',

          'badge badge-danger': form.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(form.status?.toLowerCase())), 3)
      ]),
      "cell-actions": _withCtx(({ row: form }) => [
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = form;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_5, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "tableFilter", "defaultFilter", "bulkDelete", "viewName", "tableForm", "addButtonText", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions"]),
    _createVNode(_component_vz_site_detail_modal, { site: _ctx.siteData }, null, 8, ["site"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: _ctx.viewName,
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${_ctx.selectedForAction.name}?`,
      onClose: _ctx.refreshList,
      onBulkDelete: _ctx.onBulkDelete
    }, null, 8, ["viewName", "showDialog", "selectedForAction", "deleteText", "onClose", "onBulkDelete"]),
    _createVNode(_component_SiteDetailModal, {
      showDialog: _ctx.showDetailDialog,
      viewName: "site_detail_modal",
      data: _ctx.selectedForAction,
      onCloseDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["showDialog", "data"])
  ], 64))
}